import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions, Router } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { ErrorInterceptor } from './helpers/errorInterceptor/error-interceptor.service';
import { ChunkErrorHandler } from './helpers/chunk-error-handler';
import { TranslateModule } from '@ngx-translate/core';
import { GenerateTokenService, IntegrationpingidLibModule } from 'integrationpingid-lib';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { SharedModule } from './components/shared/shared.module';
import { SessionService } from './services/shared/session/session.service';
import { LocalStorageService } from './services/shared/local-storage/local-storage.service';
import { SharedService } from './services/shared/shared.service';
import { environment } from 'src/environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ChunkErrorHandler },

    // GenerateTokenService con factory
    {
      provide: GenerateTokenService,
      useFactory: (router: Router, http: HttpClient) => {
        return new GenerateTokenService(router, http);
      },
      deps: [Router, HttpClient]
    },

    // Módulos Legacy
    importProvidersFrom(
      TranslateModule.forRoot(),
      IntegrationpingidLibModule,
      AngularMaterialModule,
      OverlayModule,
      SharedModule
    )
  ]
};